import { render, staticRenderFns } from "./relatives_manage.vue?vue&type=template&id=1cecdae8&scoped=true"
import script from "./relatives_manage.vue?vue&type=script&lang=js"
export * from "./relatives_manage.vue?vue&type=script&lang=js"
import style0 from "./relatives_manage.vue?vue&type=style&index=0&id=1cecdae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cecdae8",
  null
  
)

export default component.exports